import { createContext, useContext } from "react";
import { PermissionScope } from "@me-team/host/main/graphql/types";
import { RolePermissionsResponse } from "../interfaces";
import { Mode } from "../RoleDetailsPage";

type RolePermissionsContextType = {
    permissions: RolePermissionsResponse | null;
    onChangeRoleName: (value: string) => void;
    onChangeRoleDescription: (value: string) => void;
    onChangePermissionScope: (moduleCode: string, actionCode: number, scopeValue: PermissionScope) => void;
    onChangePermissionAction: (moduleCode: string, actionCode: number, checked: boolean) => void;
    onChangePermissionCategory: (moduleCode: string, categoryCode: string, checked: boolean) => void;
    onChangeAllPermissions: (checked: boolean) => void;
    mode: Mode;
};

const RolePermissionsContext = createContext<RolePermissionsContextType | null>(null);

export const useRolePermissionsContext = () => {
    const context = useContext(RolePermissionsContext);

    if (!context) {
        throw new Error("useRolePermissionsContext must be used within provider");
    }

    return context;
};

export default RolePermissionsContext;
